import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, ArrowLeft } from "lucide-react";
import AuthLayout from "@/components/AuthLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { apiError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("If an account exists, a reset link has been sent.");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Forgot password"
      subtitle="Enter your email and we'll send you a reset link."
      footer={
        <Link to="/login" className="inline-flex items-center gap-1 text-secondary underline">
          <ArrowLeft className="h-3 w-3" /> Back to login
        </Link>
      }
    >
      {sent ? (
        <div className="rounded-lg border border-accent/30 bg-accent/5 p-5 text-sm" data-testid="forgot-sent-msg">
          Check your inbox for a password reset link. Didn't get it? Check spam or try again.
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5">
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" data-testid="forgot-email-input" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)} className="h-11" />
          </div>
          <Button data-testid="forgot-submit-btn" type="submit" disabled={loading} className="h-11 w-full rounded-full">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Send Reset Link"}
          </Button>
        </form>
      )}
    </AuthLayout>
  );
}
